import { type FC } from "react";
import { useParams } from "react-router-dom";
import { agentName } from "../types";
import { CdpExpertAgent } from "../agent/components/CdpExpertAgent";
import { DocumentReviewerAgent } from "../agent/components/DocumentReviewerAgent";
import { EvsExpertAgent } from "../agent/components/EvsExpertAgent";
import { QuickAnswerAgent } from "../agent/components/QuickAnswer";

export const Agent: FC = () => {
    const { agent_id } = useParams();

    if (agent_id === agentName.cdp_expert) {
        return <CdpExpertAgent />;
    }
    if (agent_id === agentName.evs_expert) {
        return <EvsExpertAgent />;
    }
    if (agent_id === agentName.doc_reviewer) {
        return <DocumentReviewerAgent />;
    }
    if (agent_id === agentName.quick_answer_suggestor) {
        return <QuickAnswerAgent />;
    }
    return null;
};
